import type { AuthSession } from '../types';

/** True when JWT session belongs to the current tenant storefront. */
export function isSessionForTenant(
  session: AuthSession | null | undefined,
  tenantSlug: string | null | undefined,
): boolean {
  if (!session || !tenantSlug) {
    return false;
  }
  if (session.type === 'platform') {
    return true;
  }
  if (session.type === 'client' || session.type === 'tenant_user') {
    return session.tenantSlug === tenantSlug;
  }
  return false;
}
